/**
 * Page de réinitialisation de mot de passe FrontOffice
 */

import { useState, FormEvent, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi, getBrandInfo } from '@e-store/shared';
import './auth.css';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Token de réinitialisation manquant.');
    }
  }, [token]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }

    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (!token) {
      setError('Token de réinitialisation manquant');
      return;
    }

    setIsSubmitting(true);

    const response = await authApi.resetPassword({ token, password });

    if (response.error) {
      setError(response.error);
      setIsSubmitting(false);
      return;
    }

    setSuccess(true);
    setIsSubmitting(false);

    setTimeout(() => {
      navigate('/login');
    }, 3000);
  };

  return (
    <div className="auth-page frontoffice">
      <div className="auth-container">
        <div className="auth-header">
          <h1>{getBrandInfo().name}</h1>
          <h2>Nouveau mot de passe</h2>
        </div>

        {success ? (
          <div className="success-block">
            <div className="success-message">
              Mot de passe modifié !
            </div>
            <p className="success-text">
              Redirection vers la page de connexion...
            </p>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}

            {token ? (
              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group">
                  <label htmlFor="password">Nouveau mot de passe</label>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Minimum 8 caractères"
                    required
                    minLength={8}
                    autoComplete="new-password"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirmez votre mot de passe"
                    required
                    minLength={8}
                    autoComplete="new-password"
                  />
                </div>

                <button type="submit" className="btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Modification...' : 'Modifier le mot de passe'}
                </button>
              </form>
            ) : (
              <div className="error-block">
                <p>Le lien est invalide ou a expiré.</p>
                <Link to="/forgot-password" className="btn-primary">
                  Demander un nouveau lien
                </Link>
              </div>
            )}
          </>
        )}

        <div className="auth-links">
          <Link to="/login" className="link">
            Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}
